import { useEffect, useRef, useState } from "react";
import { mountOrb, ORB_CANVAS_STYLE } from "@/lib/orb-shader";

/**
 * The live shader orb inside the chat launcher (launcher.icon "orb"). Draws
 * with src/lib/orb-shader.ts — the same code the loader's launcher runs, on
 * the same shared clock — and falls back to the still poster when WebGL is
 * unavailable.
 */
export default function OrbCanvas({ poster }: { poster: string }) {
  const ref = useRef<HTMLCanvasElement>(null);
  const [fallback, setFallback] = useState(false);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const destroy = mountOrb(canvas);
    if (!destroy) {
      setFallback(true);
      return;
    }
    return destroy;
  }, []);

  if (fallback) {
    return (
      <img
        src={poster}
        alt=""
        aria-hidden="true"
        style={{ display: "block", width: "100%", height: "100%", objectFit: "contain", pointerEvents: "none" }}
      />
    );
  }
  return (
    <canvas
      ref={ref}
      aria-hidden="true"
      style={{ display: "block", width: "100%", height: "100%", pointerEvents: "none", background: "transparent" }}
      data-orb-style={ORB_CANVAS_STYLE}
    />
  );
}
